import React from 'react';
import { Tooltip } from "@mui/material";

import * as stringUtils from '../../../util/stringUtil';
import * as apiUtil from "../../../util/apiUtil";

import './CashChargedComp.css'
import * as tokenUtil from "../../../util/tokenUtil";
import PackageTermsModal from "../component/modal/PackageTermsModal";

class CashChargedComp extends React.Component {
    constructor(props) {
        super(props);

        this.selectTotalAmount = this.selectTotalAmount.bind(this);
        this.changeSelfAmount = this.changeSelfAmount.bind(this);
        this.requestPayment = this.requestPayment.bind(this);
        this.ajaxGetUserMessageInfo = this.ajaxGetUserMessageInfo.bind(this);
        this.handleMediaChange = this.handleMediaChange.bind(this);
        this.getFilteredSendableData = this.getFilteredSendableData.bind(this);
        this.selectPackage = this.selectPackage.bind(this);
        this.handlePackageTermModalClose = this.handlePackageTermModalClose.bind(this);

        this.submitPay = this.submitPay.bind(this);

        this.state = {
            isLoggedIn: tokenUtil.getAccessToken(),
            textPrice: 120,
            imagePrice: 140,

            mediaData: [
                { name: 'SKT', minCount: 1000, lmsPrice: 120, mmsPrice: 140 },
                { name: 'KB국민카드', minCount: 30000, lmsPrice: 100, mmsPrice: 180 },
                { name: 'CJONE', minCount: 50000, lmsPrice: 100, mmsPrice: 150 },
                { name: 'L.POINT', minCount: 30000, lmsPrice: 90, mmsPrice: 150 },
            ],

            packageList: [
                { name: '자동 발송 패키지\n텍스트', price:360000 },
                { name: '자동 발송 패키지\n이미지', price:420000 },
            ],

            packageModalOpened: false,
            packageIdx: 0,

            sndAmount: 132000,
            chargePriceList: [120000, 360000, 600000, 1200000, 6000000],
            price: "120000",
            selectedMedia: ['SKT'], // 기본값: SKT만 선택
            userPackage: null,
            canBuyPackage: false,

            sndPaymethod: '',
            KSPayInfo: {
                sndStoreid: "",
                sndOrdernumber: "",
                sndGoodname: "",
                sndAmount: "",
                sndOrdername: "",
                sndEmail: "",
                sndMobile: "",
                sndReply: "",
                sndGoodType: "",
                sndCharSet: "",
                sndShowcard: "",
                sndCurrencytype: "",
                sndInstallmenttype: "",
                sndInteresttype: "",
                sndEscrow: '',
                sndVirExpDt: '',
                sndVirExpTm: '',
                sndCashReceipt: ''
            }
        };
    }//end constructor
    componentDidMount() {
        const { isLoggedIn } = this.state;
        if(isLoggedIn) this.ajaxGetUserMessageInfo();
        this.loadScript("https://kspay.ksnet.to/store/KSPayWebV1.4/js/kspay_web_ssl.js");
    }
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.state.sndPaymethod !== nextState.sndPaymethod
            || this.state.sndAmount !== nextState.sndAmount
            || this.state.KSPayInfo !== nextState.KSPayInfo
            || this.state.textPrice !== nextState.textPrice
            || this.state.imagePrice !== nextState.imagePrice
            || this.state.selfPrice !== nextState.selfPrice
            || this.state.selectedMedia !== nextState.selectedMedia
            || this.state.price !== nextState.price
            || this.state.packageModalOpened !== nextState.packageModalOpened
            || this.state.packageIdx !== nextState.packageIdx
            || this.state.userPackage !== nextState.userPackage
            || this.state.canBuyPackage !== nextState.canBuyPackage
        )
    }

    loadScript = (src) => {
        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.onload = () => {
        };

        document.body.appendChild(script);
    }

    selectTotalAmount(e) {
        let value = e.target.value;

        if (!value) value = "0";

        if (typeof value === "string") {
            value = value.replace(/,/g, "");
        } else if(typeof value === "number") {
            value = String(value);
        }

        const price = Number(value);

        if (isNaN(price)) return;

        this.setState({ sndAmount: Math.floor(price * 1.1), price: price });
    }

    changeSelfAmount(e) {
        const input = e.target;
        let caret = input.selectionStart;

        const oldValue = input.value;
        const raw = oldValue.replace(/,/g, "");

        // 숫자 아닌 입력 차단
        if (!/^\d*$/.test(raw)) return;

        // 숫자값
        const price = raw === "" ? 0 : Number(raw);

        // formatted
        const formatted = raw === "" ? "" : price.toLocaleString();

        // === 커서 위치 보정 ===
        let oldCommaCount = (oldValue.slice(0, caret).match(/,/g) || []).length;
        let newCommaCount = (formatted.slice(0, caret).match(/,/g) || []).length;
        let newCaret = caret + (newCommaCount - oldCommaCount);
        const selectedRadio = document.querySelector('input[name="PRICE"]:checked');

        // 상태 업데이트
        this.setState(
            {
                selfPrice: formatted,
            },() => {
                const isSelfInputSelected = selectedRadio && selectedRadio.dataset.inputType === 'self-input';
                if (isSelfInputSelected) {
                    this.setState({
                        sndAmount: Math.floor(price * 1.1),
                        price: price
                    });
                }
                // 커서 위치 보정
                setTimeout(() => {
                    input.selectionStart = newCaret;
                    input.selectionEnd = newCaret;
                });
            }
        );
    }

    async requestPayment(id, isPackage) {
        const { sndAmount, price, packageList, packageIdx } = this.state;

        let finalAmount = sndAmount;
        let finalPrice = price;

        if(!isPackage) {
            if (document.querySelector('input[name="PRICE"]:checked').dataset.inputType === 'self-input' && sndAmount <= 0) {
                alert("결제 금액을 입력해주세요.");
                return;
            }

            if (sndAmount === 0) {
                alert("결제 금액을 선택해주셔야 합니다.");
                return;
            }

            if (price % 10000 !== 0) {
                alert("충전 단위는 10,000원 단위로 가능합니다. (* VAT 별도)");
                return;
            }
        } else {
            finalPrice = packageList[packageIdx].price;
            finalAmount = Math.floor(finalPrice * 1.1);
        }

        switch (id) {
            case "Card":
                await this.setState({sndPaymethod: '1000000000000'})
                break;
            case "DirectBank":
                await this.setState({sndPaymethod: '0010000000000'})
                return;
            case "VBank":
                await this.setState({sndPaymethod: '0100000000000'})
                break;
            default:
                break;
        }// end switch

        const type = isPackage ? "package" : "point";
        apiUtil.asyncRequest({
            url: `/api/cash/payment/ready/${finalAmount}/${id}?price=${finalPrice}&type=${type}`,
            method: apiUtil.requestMethod.GET,
            success: async (result) => {
                if(isPackage) {
                    await this.setState({packageModalOpened : false});
                }
                await this.setState({
                    KSPayInfo:{
                        sndStoreid: result.sndStoreid,
                        sndOrdernumber: result.sndOrdernumber,
                        sndGoodname: result.sndGoodname,
                        sndAmount: result.sndAmount,
                        sndOrdername: result.sndOrdername,
                        sndEmail: result.sndEmail,
                        sndMobile: result.sndMobile,
                        sndReply: result.sndReply,
                        sndGoodType: result.sndGoodType,
                        sndCharSet: result.sndCharSet,
                        sndShowcard: result.sndShowcard,
                        sndCurrencytype: result.sndCurrencytype,
                        sndInstallmenttype: result.sndInstallmenttype,
                        sndInteresttype: result.sndInteresttype,
                        sndEscrow: result.sndEscrow,
                        sndVirExpDt: result.sndVirExpDt,
                        sndVirExpTm: result.sndVirExpTm,
                        sndCashReceipt: result.sndCashReceipt,
                    }}, () => this.submitPay(isPackage));
            }
        })
    }

    async submitPay(isPackage) {
        const { KSPayInfo } = this.state;
        const form = document.getElementById('paymentForm');
        const formData = new FormData(form);

        // 팝업창 열기
        const popup = window.open('', '_blank', 'width=1000,height=800');
        const formAction = form.getAttribute('action');

        popup.document.open();
        popup.document.write(`
            <html>
            <head><title>결제 진행</title></head>
            <body>
                <form action="${formAction}" method="POST" target="_self">
                    ${Array.from(formData.entries()).map(([name, value]) => `
                        <input type="hidden" name="${name}" value="${value}" />
                    `).join('')}
                    <button type="submit">Submit</button>
                </form>
                <script>
                    document.forms[0].submit();
                </script>
            </body>
            </html>
        `);
        popup.document.close();

        const checkPopupClosed = setInterval(() => {
            if (popup.closed) {
                if(!isPackage) {
                    apiUtil.asyncRequest({
                        url: `/api/cash/payment/create?ordernum=${KSPayInfo.sndOrdernumber}`,
                        method: apiUtil.requestMethod.POST,
                        success: async (result) => {
                            if (result !== null && result !== undefined && result.includes('결제')) alert(result);
                            else {
                                alert("완료 되었습니다! 감사합니다!");
                                window.location.href = "/cash/history";
                            }
                        }
                    })
                    clearInterval(checkPopupClosed);
                } else {
                    const { packageIdx } = this.state;
                    const packageName = packageIdx === 0 ? 'T' : 'I';

                    apiUtil.asyncRequest({
                        url: `/api/cash/payment/package/${packageName}/create?ordernum=${KSPayInfo.sndOrdernumber}`,
                        method: apiUtil.requestMethod.POST,
                        success: async (result) => {
                            if (result !== null && result !== undefined && result.includes('결제')) alert(result);
                            else {
                                alert("완료 되었습니다! 감사합니다!");
                                window.location.href = "/cash/history";
                            }
                        }
                    })
                    clearInterval(checkPopupClosed);
                }
            }
        }, 1000);
    }

    ajaxGetUserMessageInfo() {
        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/user/info/message",
            method: apiUtil.requestMethod.POST,
            success: (result) => {
                const newMediaData = [...this.state.mediaData];
                newMediaData[0] = {
                    ...newMediaData[0],
                    lmsPrice: result.txtMessageUnit,
                    mmsPrice: result.imgMessageUnit,
                };
                this.setState({ userPackage: result.userPackage, textPrice: result.txtMessageUnit, imagePrice: result.imgMessageUnit, mediaData: newMediaData, canBuyPackage : result.canBuyPackage });
            }
        })
    }

    // 매체사 체크박스 변경 핸들러 메서드
    handleMediaChange = (mediaName) => {
        this.setState(prevState => {
            const prevSelected = prevState.selectedMedia;
            if (prevSelected.includes(mediaName)) {
                return {
                    selectedMedia: prevSelected.filter(name => name !== mediaName)
                };
            } else {
                return {
                    selectedMedia: [...prevSelected, mediaName]
                };
            }
        });
    };

    // 발송 가능 건수 필터링
    getFilteredSendableData = () => {
        const { selectedMedia, mediaData } = this.state;
        return mediaData.filter(media => selectedMedia.includes(media.name));
    }

    handlePackageTermModalClose() {
        this.setState({ packageModalOpened : false });
    }

    selectPackage(idx) {
        const { userPackage, canBuyPackage, isLoggedIn } = this.state;

        if (!isLoggedIn) {
            window.alert("로그인 후 이용해 주시기 바랍니다.");
            window.location.href = "/account/login";
            return;
        }

        if((userPackage !== null && userPackage !== undefined)) {
            window.alert("현재 [" + userPackage.name + "]를 이용 중입니다.\n패키지는 하나만 보유 가능하며,\n소진 후 다시 이용해 주시기 바랍니다.");
            return;
        } else if (!canBuyPackage) {
            window.alert("현재 결제 진행 중인 패키지가 존재합니다.\n결제 완료 후 이용해 주시기 바랍니다.");
            return;
        }

        this.setState({packageIdx: idx, packageModalOpened : true});
    }


    render() {
        const { textPrice, imagePrice, chargePriceList, KSPayInfo, sndPaymethod, isLoggedIn, selfPrice, selectedMedia, price, mediaData } = this.state;
        const { selectTotalAmount, requestPayment, changeSelfAmount, handlePackageTermModalClose, selectPackage } = this;
        const { packageModalOpened, packageList } = this.state;

        const numericSelfPrice = Number(selfPrice?.replace(/,/g, "")) || 0;

        return (
            <>
                <section className='container-xxl pay-info'>
                    <h2 className='fs-4'>충전</h2>
                    <div className='card'>
                        <div className='card-body p-lg-5'>
                            {/*화면설계도 50에 해당하는 캐시 충전 */}
                            <div className='container-sm mb-3'>
                                <div className='bg-primary'>
                                    비즈팅은 통신사 및 카드사, 포인트사의 고객 데이터를 활용하여 내 고객이 아닌 대상에게
                                    <br className='d-none d-md-inline '/>
                                    마케팅 메시지를 발송할 수 있는 신개념 마케팅 솔루션입니다.
                                </div>
                                <div className='d-flex justify-content-center p-sm-4 fs-6'>
                                    <ul className='text-left'>
                                        <li>선불 결제로 충전한 캐시로 마케팅 메시지를 보낼 수 있습니다.</li>
                                        <li>충전된 포인트는 구매일(충전일)로부터 12개월간 유효합니다.</li>
                                        <li>환불은 결제된 수단으로만 환불이 가능하며, 환불 불가 금액(5,000원 미만)은 환불 불가합니다.</li>
                                        <li>충전 단위는 10,000원 단위로 가능합니다.</li>
                                        <li style={{color:'red'}}>충전하실 경우, 최소 발송 건수를 고려하여 충전해 주시기 바랍니다.</li>
                                        <li>SKT 타겟팅 메시지를 사용하는 경우, 충전 후 바로 서비스를 이용하실 수 있습니다.</li>
                                        <li style={{color:'red'}}>SKT 외 타 매체사 사용을 희망하시는 경우에는 충전 후 꼭 1:1문의 &gt;도입문의 카테고리에 문의를 남겨주시기 바랍니다.</li>
                                        <li>농협카드(NHPay)의 경우, 1일 50만원/1회 10만원/1일 횟수 10회 결제 가능합니다.</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="text-center my-4">
                                <div className="package-header mb-3">
                                    <div className="package-header-title">
                                        비즈팅 <span className="best">Best</span> 패키지 요금제
                                    </div>
                                    <div className="package-header-sub package-header-sub-bold">
                                        더 낮아진 최소발송 건수! + 캠페인 자동 발송
                                    </div>
                                    <div className="package-header-sub package-header-sub-bold">
                                        500건씩 총 6회 발송!
                                    </div>
                                    <div className="package-header-sub">
                                        첫 캠페인 집행만으로 나머지 캠페인은 <span className="best package-header-sub-bold">자동 발송</span>됩니다.
                                    </div>
                                    <div className="package-header-sub">
                                        번거로운 재설정 없이 <span className="package-header-sub-bold">정해진 일정에 맞춰 알아서 발송!</span>
                                    </div>
                                </div>

                                {/*<div className="d-flex justify-content-center mb-4">*/}
                                {/*    <ul className="text-start">*/}
                                {/*        <li>500건씩 6번 다양한 컨텐츠로 발송!</li>*/}
                                {/*        <li>반응률 좋은 캠페인으로 고객들의 마음을 사로잡으세요!</li>*/}
                                {/*    </ul>*/}
                                {/*</div>*/}

                                <div className="row justify-content-center gap-3">
                                    {packageList.map((pkg, index) => {
                                        const typeClass = index === 0 ? 'text' : 'image';

                                        return (
                                            <div
                                                key={index}
                                                className={`
                                                    col-12 col-md-4
                                                    package-card
                                                    ${typeClass}
                                                `}
                                                onClick={() => selectPackage(index)}
                                            >
                                                <div className={`package-title ${typeClass}`}>
                                                    {pkg.name.split('\n').map((line, i) => (
                                                        <div key={i}>{line}</div>
                                                    ))}
                                                </div>

                                                <div className="package-price">
                                                    {pkg.price.toLocaleString()}원
                                                </div>

                                                <div className={`package-charge ${typeClass}`}>
                                                    → 결제 바로가기
                                                </div>

                                                <div className="package-vat">
                                                    vat 별도
                                                </div>
                                            </div>
                                        );
                                    })}
                                    <div className="">
                                        <span style={{color:'red'}}>*패키지 요금제의 목표 발송 가능 일자는 구매일로부터 90일 이내까지 설정 가능합니다.</span>
                                    </div>
                                </div>
                            </div>

                            {/* 매체사 선택 및 단가/건수 표 섹션 시작 */}
                            <div className='container-sm2 mt-5'>
                                {/* A. 매체사 선택 드롭다운 */}
                                <div className="d-flex justify-content-end mb-3">
                                    <div className="dropdown media-select-dropdown">
                                        <button
                                            className="btn btn-sm btn-outline-secondary dropdown-toggle"
                                            type="button"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            매체사 선택
                                        </button>
                                        <ul className="dropdown-menu dropdown-menu-end p-2 media-checkbox-menu">
                                            {mediaData.map(media => (
                                                <li key={media.name}>
                                                    <div className="form-check pointer white-space-nowrap">
                                                        <input
                                                            className="form-check-input pointer"
                                                            type="checkbox"
                                                            value={media.name}
                                                            id={`check-${media.name}`}
                                                            checked={selectedMedia.includes(media.name)}
                                                            onChange={() => this.handleMediaChange(media.name)}
                                                        />
                                                        <label className="form-check-label pointer" htmlFor={`check-${media.name}`}>
                                                            {media.name}
                                                        </label>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>

                                {/* B. 매체사별 단가 정보 표 (상단 표) */}
                                <div className="table-responsive mb-5">
                                    <table className="table table-bordered text-center table-hover">
                                        <thead>
                                        <tr className="table-primary border fs-5">
                                            <th className="w-10 white-space-nowrap" style={{color:'red'}}>*VAT 별도</th>
                                            {mediaData.map(media => (
                                                <th key={media.name} className="text-primary white-space-nowrap">{media.name}</th>
                                            ))}
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <th className="text-start">최소 발송 건수</th>
                                            {mediaData.map(media => (
                                                <td key={`${media.name}-min-count`}>{stringUtils.formatNumber(media.minCount)}건</td>
                                            ))}
                                        </tr>
                                        <tr>
                                            <th className="text-start">LMS(텍스트) 단가</th>
                                            {mediaData.map(media => (
                                                <td key={`${media.name}-lms-price`}>{stringUtils.formatNumber(media.lmsPrice)}원</td>
                                            ))}
                                        </tr>
                                        <tr>
                                            <th className="text-start">MMS(이미지) 단가</th>
                                            {mediaData.map(media => (
                                                <td key={`${media.name}-mms-price`}>{stringUtils.formatNumber(media.mmsPrice)}원</td>
                                            ))}
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {/* 매체사 선택 및 단가/건수 표 섹션 끝 */}

                            {/*2번에 해당하는 요금제 표 table*/}
                            {textPrice !== 0 && imagePrice !== 0 && (
                                <div className='container-sm mt-5'>
                                    <div className='table-responsive'>
                                        <table className="table table-bordered text-center table-hover">
                                            <thead className={"table-primary border fs-5"}>
                                                <tr>
                                                    {/*위치를 위한 빈칸*/}
                                                    <th className='w-10'></th>
                                                    <th className={'text-primary w-40'}>결제 금액 <br/> <p style={{color:'red', margin:'0'}}>(VAT 별도)</p></th>
                                                    <th className={'text-primary w-40'}>충전 포인트</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    chargePriceList.map((price, index) => (
                                                        <tr key={index}>
                                                            <td>{
                                                                isLoggedIn &&
                                                                    <input className='form-check-input'
                                                                            type="radio"
                                                                            name="PRICE" value={price}
                                                                            onChange={selectTotalAmount}
                                                                            defaultChecked={index === 0} />
                                                            }</td>
                                                            <td>{stringUtils.formatNumber(price)} 원</td>
                                                            <td>{stringUtils.formatNumber(price)} P</td>
                                                        </tr>
                                                    ))
                                                }
                                                <tr className="align-middle" key={chargePriceList.length + 1}>
                                                    <td>{isLoggedIn && <input className='form-check-input' type="radio" name="PRICE" value={selfPrice} onChange={selectTotalAmount} data-input-type="self-input"/>}</td>
                                                    <td><input className="input-modern" placeholder="직접 입력하기"  autoComplete="off"
                                                               value={selfPrice?.toLocaleString() ?? ""} name="PRICE" style={{ textAlign: "center" }} onChange={changeSelfAmount} /> 원</td>
                                                    <td>{stringUtils.formatNumber(numericSelfPrice)} P</td>
                                                </tr>
                                            </tbody>


                                            <tfoot className='table-primary  text-center'>
                                            {isLoggedIn && <tr>
                                                <td colSpan={3}>
                                                    <div
                                                        className='flex-column flex-sm-row  d-flex  justify-content-center'>
                                                        <button
                                                            className='btn btn-primary btn-md d-sm-inline-block d-block my-1 mx-1'
                                                            onClick={() => requestPayment("Card", false)}>
                                                                <span className='d-flex align-items-center'>신용카드
                                                                <span
                                                                    className="ps-1 mx-1 material-symbols-rounded">credit_card</span>
                                                                </span>

                                                        </button>
                                                        {/*<button*/}
                                                        {/*    className='btn btn-primary btn-md my-1  mx-1 d-sm-inline-block d-block'*/}
                                                        {/*    onClick={() => requestPayment("DirectBank", false)}>*/}
                                                        {/*        <span className='d-flex align-items-center'>실시간 계좌이체*/}
                                                        {/*        <span*/}
                                                        {/*            className="ps-1 mx-1 material-symbols-rounded">send_money</span></span>*/}
                                                        {/*</button>*/}
                                                        <button
                                                            className='btn btn-primary btn-md my-1  mx-1 d-sm-inline-block d-block'
                                                            onClick={() => requestPayment("VBank", false)}>
                                                                <span className='d-flex align-items-center'>무통장 입금
                                                                  <span
                                                                      className="ps-1 mx-1 material-symbols-rounded">payments</span></span>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>}

                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                            )}
                            <p style={{color: 'red', textAlign: 'center', wordBreak: 'keep-all', marginTop: '0.75rem', marginBottom: 0, fontSize: '0.85rem'}}>
                                * 분양 광고는 반드시 <strong>1:1 문의</strong> 부탁드립니다. 비즈팅 사이트 내에서는 분양광고 진행이 어려우며, <strong>대행발송으로 진행</strong>되는 점 참고 부탁드립니다. <strong>포인트 충전 전 반드시 확인 부탁드립니다.</strong>
                            </p>
                            <div className='container-sm3 mt-5'>
                                {/* C. 발송 가능 건수 표 (하단 표) */}
                                <div className='d-flex align-items-center mb-3'>
                                    <h5 className='fs-5 mb-0 me-2'>발송 가능 건수 (선택된 매체사 기준 자동계산)</h5>
                                    <div className="tooltip-area h-fix">
                                        {Tooltip && <Tooltip title={"발송 가능 건수는 포인트 충전 금액에 따라 계산되며, 매체사별로 다릅니다."}>
                                            <span className="material-symbols-rounded fs-5 ps-1 pointer text-muted">info</span>
                                        </Tooltip>}
                                    </div>
                                </div>

                                {this.getFilteredSendableData().length > 0 ? (
                                    <div className="table-responsive">
                                        <table className="table table-bordered text-center table-hover">
                                            <thead>
                                            <tr className="table-primary border fs-5">
                                                <th className='text-primary'>매체사</th>
                                                <th className='text-primary'>충전 포인트</th>
                                                <th colSpan="2" className='text-primary'>발송 가능 건수</th>
                                            </tr>
                                            <tr className='table-primary border'>
                                                <th></th>
                                                <th></th>
                                                <th className='text-primary'>텍스트(LMS)</th>
                                                <th className='text-primary'>이미지(MMS)</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {/* 💡 선택된 매체사 데이터만 표시 */}
                                            {this.getFilteredSendableData().map(media => (
                                                <tr key={media.name}>
                                                    <th className="text-center">{media.name}</th>
                                                    <td>{stringUtils.formatNumber(price)}P</td>
                                                    <td>{media.minCount * media.lmsPrice <= price ? stringUtils.formatNumber(Math.floor(price / media.lmsPrice)) + ' 건' : '최소발송건수 미충족'}</td>
                                                    <td>{media.minCount * media.mmsPrice <= price ? stringUtils.formatNumber(Math.floor(price / media.mmsPrice)) + ' 건' : '최소발송건수 미충족'}</td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <div className="alert alert-warning">
                                        발송 가능 건수를 확인하려면 매체사를 1개 이상 선택해야 합니다.
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </section>

                <PackageTermsModal
                    isOpen={packageModalOpened}
                    handleClose={handlePackageTermModalClose}
                    requestPayment={requestPayment}
                />
                {/*결제 관련 내용*/}
                <form id="paymentForm" className="visually-hidden"
                      action="https://kspay.ksnet.to/store/KSPayWebV1.4/KSPayPWeb.jsp" method="POST">
                    <input name="sndPaymethod" type="hidden" value={sndPaymethod}/>
                    <input name="sndStoreid" type="hidden" value={KSPayInfo.sndStoreid}/>
                    <input name="sndOrdernumber" type="hidden" value={KSPayInfo.sndOrdernumber}/>
                    <input name="sndGoodname" type="hidden" value={KSPayInfo.sndGoodname}/>
                    <input name="sndAmount" type="hidden" value={KSPayInfo.sndAmount}/>
                    <input name="sndOrdername" type="hidden" value={KSPayInfo.sndOrdername}/>
                    <input name="sndEmail" type="hidden" value={KSPayInfo.sndEmail}/>
                    <input name="sndReply" type="hidden" value={KSPayInfo.sndReply}/>
                    <input name="sndGoodType" type="hidden" value={KSPayInfo.sndGoodType}/>
                    <input name="sndCharSet" type="hidden" value={KSPayInfo.sndCharSet}/>
                    <input name="sndShowcard" type="hidden" value={KSPayInfo.sndShowcard}/>
                    <input name="sndCurrencytype" type="hidden" value={KSPayInfo.sndCurrencytype}/>
                    <input name="sndInstallmenttype" type="hidden" value={KSPayInfo.sndInstallmenttype}/>
                    <input name="sndInteresttype" type="hidden" value={KSPayInfo.sndInteresttype}/>
                    <input name="sndEscrow" type="hidden" value={KSPayInfo.sndEscrow}/>
                    <input name="sndVirExpDt" type="hidden" value={KSPayInfo.sndVirExpDt}/>
                    <input name="sndVirExpTm" type="hidden" value={KSPayInfo.sndVirExpTm}/>
                    <input name="sndCashReceipt" type="hidden" value={KSPayInfo.sndCashReceipt}/>
                    <input name="sndQpayType" type="hidden" value="0"/>
                </form>
            </>
        )
    }// end render
}

export default CashChargedComp;
